import React, { createContext, useContext, useState, useEffect } from 'react';
import { authService } from '../services/authService';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const token = localStorage.getItem('discord_token');
        if (token) {
          const userData = await authService.getUserInfo(token);
          setUser(userData);
        }
      } catch (err) {
        console.error('Auth check failed:', err);
        localStorage.removeItem('discord_token');
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  const login = () => {
    authService.login();
  };

  const logout = () => {
    localStorage.removeItem('discord_token');
    setUser(null);
  };

  const handleCallback = async (code, state) => {
    console.log('Handling callback with code:', code?.substring(0, 10) + '...');
    try {
      const { access_token, user: userData } = await authService.exchangeCode(code, state);
      console.log('Token exchange successful, user:', userData?.username);
      localStorage.setItem('discord_token', access_token);
      setUser(userData);
      return true;
    } catch (err) {
      console.error('Token exchange failed:', err);
      setError(err.message);
      return false;
    }
  };

  const value = {
    user,
    loading,
    error,
    login,
    logout,
    handleCallback,
    isAuthenticated: !!user
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
